export function resolveSolanaBypassEnabledFromRuntimeConfig(
  runtimeConfig: Record<string, unknown> | null | undefined
): boolean {
  const value = runtimeConfig?.SOLANA_ONCHAIN_POLICY_BYPASS_ENABLED
  if (typeof value === 'boolean') return value
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>
    return typeof record.default === 'boolean' ? record.default : false
  }
  return false
}

export function parseBudgetSubsidyInput(value: string): { valid: boolean; value: number } {
  const trimmed = value.trim()
  if (!trimmed) return { valid: true, value: 0 }
  if (!/^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/u.test(trimmed)) {
    return { valid: false, value: 0 }
  }
  const parsed = Number(trimmed)
  return Number.isFinite(parsed) && parsed >= 0
    ? { valid: true, value: parsed }
    : { valid: false, value: 0 }
}

export function isBudgetSubsidyReductionOnly(
  storedSubsidyUsd: number,
  planOverrideConfigurable: boolean
): boolean {
  return storedSubsidyUsd > 0 && !planOverrideConfigurable
}

export function isBudgetSubsidyIncreaseUnavailable(params: {
  storedSubsidyUsd: number
  nextSubsidyUsd: number
  planOverrideConfigurable: boolean
}): boolean {
  return params.nextSubsidyUsd > params.storedSubsidyUsd
    && !params.planOverrideConfigurable
}
